import { setGlobalLoader } from "../../redux/loader/loader-reducer";
import { store } from "../../redux/store";

export const showLoader = () => {
    store.dispatch(setGlobalLoader(true));
}

export const hideLoader = () => {
    store.dispatch(setGlobalLoader(false));
}